(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var routes = window.routes || {};
  var lastFocus = null;

  /* ---------- Cart drawer ---------- */
  function drawer() { return window.cartDrawerEnabled ? $('[data-cart-drawer]') : null; }

  function openDrawer() {
    var d = drawer(); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var close = $('.cart-drawer__head [data-drawer-close]', d);
    if (close) close.focus();
  }

  function closeDrawer() {
    var d = drawer(); if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = Number(n) === 0;
    });
  }

  function refreshDrawer() {
    return fetch(routes.cart_url + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        var next = $('[data-cart-drawer-content]', html);
        var cur = $('[data-cart-drawer-content]');
        if (next && cur) {
          cur.replaceWith(next);
          setCount(next.getAttribute('data-item-count'));
        }
      });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var toggle = t.closest('[data-cart-toggle]');
    if (toggle && drawer()) { e.preventDefault(); refreshDrawer().then(openDrawer, openDrawer); return; }
    if (t.closest('[data-drawer-close]')) { closeDrawer(); return; }

    var change = t.closest('[data-cart-change]');
    if (change) {
      e.preventDefault();
      change.disabled = true;
      fetch(routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(change.dataset.line), quantity: Number(change.dataset.quantity) })
      }).then(refreshDrawer).catch(function () { change.disabled = false; });
      return;
    }

    var s = t.closest('[data-search-toggle]');
    if (s) {
      var panel = $('[data-search-panel]');
      var open = panel.hidden;
      panel.hidden = !open;
      s.setAttribute('aria-expanded', String(open));
      if (open) { var input = $('input[type=search]', panel); if (input) input.focus(); }
      return;
    }

    var m = t.closest('[data-menu-toggle]');
    if (m) {
      var menu = $('[data-mobile-menu]');
      var show = menu.hidden;
      menu.hidden = !show;
      m.setAttribute('aria-expanded', String(show));
      return;
    }

    var thumb = t.closest('[data-thumb]');
    if (thumb) { showMedia(thumb.dataset.thumb); return; }

    var minus = t.closest('[data-qty-minus]');
    var plus = t.closest('[data-qty-plus]');
    if (minus || plus) {
      var input2 = $('input', (minus || plus).closest('[data-qty]'));
      var v = parseInt(input2.value, 10) || 1;
      input2.value = Math.max(1, v + (plus ? 1 : -1));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var d = drawer();
      if (d && d.classList.contains('is-open')) closeDrawer();
    }
  });

  /* ---------- Ajax add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form || !drawer()) return;
    e.preventDefault();
    var btn = $('[type=submit]', form);
    var err = $('[data-form-error]', form);
    if (err) err.textContent = '';
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    fetch(routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) throw new Error(res.json.description || res.json.message || 'We could not add that to your bag.');
        return refreshDrawer().then(openDrawer);
      })
      .catch(function (ex) { if (err) err.textContent = ex.message; })
      .then(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); });
  });

  /* ---------- Product page ---------- */
  function showMedia(id) {
    $$('[data-media]').forEach(function (el) { el.hidden = String(el.dataset.media) !== String(id); });
    $$('[data-thumb]').forEach(function (el) { el.classList.toggle('is-active', String(el.dataset.thumb) === String(id)); });
  }

  function initProduct() {
    var section = $('[data-product-section]');
    var dataEl = section && $('[data-variants]', section);
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var form = $('#ProductForm', section);
    var idInput = $('[data-variant-id]', form);
    var addBtn = $('[data-add-button]', form);
    var addLabel = $('[data-add-label]', form);
    var priceBox = $('[data-price]', section);

    function selected() {
      return $$('[data-option-index]', form).map(function (f) {
        var c = $('input:checked', f); return c ? c.value : null;
      });
    }

    function update() {
      var opts = selected();
      var match = variants.filter(function (v) {
        return opts.length === 0 || v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
      if (!match) {
        addBtn.disabled = true; addLabel.textContent = 'Unavailable'; return;
      }
      idInput.value = match.id;
      addBtn.disabled = !match.available;
      addLabel.textContent = match.available ? 'Add to cart' : 'Sold out';
      priceBox.innerHTML = match.compare && match.available
        ? '<div class="price price--sale"><s class="price__compare">' + match.compare + '</s><span class="price__now">' + match.price + '</span></div>'
        : '<div class="price"><span class="price__now">' + match.price + '</span></div>';
      if (match.media) showMedia(match.media);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }

    form.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) update();
    });
  }

  /* ---------- Related products ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      if (el.children.length || !el.dataset.url) return;
      fetch(el.dataset.url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var next = $('[data-recommendations]', doc);
          if (next && next.children.length) el.innerHTML = next.innerHTML;
        })
        .catch(function () {});
    });
  }

  /* ---------- Collection sort ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-sort]');
    if (!sel) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  function init() { initProduct(); initRecommendations(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
